// Copyright (c) 2022 Deere & Company

import './dealer-search-modal.scss';
import React, {PropTypes} from 'react';
import DealerSearch from '../../../../product/dealer-search/state-connector';
import {FormattedMessage} from 'react-intl';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

const DealerSearchModal = props =>
    <section className='dealer-search-modal'>
        <WarrantyMediumModal isOpen={props.isOpen}>
            <header>
                <FormattedMessage id='CHANGE_RESPONSIBLE_DEALER'/>
                <span
                    className='close-modal-icon'
                    onClick={props.onClose}
                />
            </header>
            <div className='modal-body'>
                <DealerSearch>
                    {props.onDealerSelect}
                    {props.isDealerClosingAccount}
                </DealerSearch>
            </div>
        </WarrantyMediumModal>
    </section>;

DealerSearchModal.displayName = 'DealerSearchModal';
DealerSearchModal.propTypes = {
    isDealerClosingAccount: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired
};

DealerSearchModal.defaultProps = {

    isDealerClosingAccount: true
};
export default DealerSearchModal;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/closing-account/dealer-search-modal.js